import RequestService from './request';

export interface WhmcsAttachmentGroup {
    identifier: string;
    templateId: string | null;
    templateName: string | null;
    attachCount: number;
    alreadyLinkedCount: number;
    skippedEggMismatch: number;
    unresolvedCount: number;
    detachCount: number;
    // False when the template has not been imported yet -- nothing to link to.
    selectable: boolean;
    warnings: string[];
}

export interface WhmcsAttachmentFailure {
    identifier: string;
    error: string;
}

export interface WhmcsAttachmentResult {
    linked: number;
    skipped: number;
    unchanged: number;
    detached: number;
    failures: WhmcsAttachmentFailure[];
}

class WhmcsAttachmentsService {
    preview(data: { url: string }): Promise<WhmcsAttachmentGroup[]> {
        return RequestService.post('/server-templates/attachments/preview', data).then((res) =>
            (res.groups ?? []).map(
                (row: Record<string, any>): WhmcsAttachmentGroup => ({
                    identifier: row.identifier,
                    templateId: row.template_id ?? null,
                    templateName: row.template_name ?? null,
                    attachCount: row.attach_count ?? 0,
                    alreadyLinkedCount: row.already_linked_count ?? 0,
                    skippedEggMismatch: row.skipped_egg_mismatch ?? 0,
                    unresolvedCount: row.unresolved_count ?? 0,
                    detachCount: row.detach_count ?? 0,
                    selectable: row.selectable ?? false,
                    warnings: row.warnings ?? [],
                }),
            ),
        );
    }

    confirm(data: { url: string; identifiers: string[]; detach: boolean }): Promise<WhmcsAttachmentResult> {
        return RequestService.post('/server-templates/attachments/confirm', data);
    }
}

export default new WhmcsAttachmentsService();
